import { createTypes } from 'reduxsauce'

const asyncTypes = (key) =>
  `
  ${key}_ATTEMPT
  ${key}_SUCCESS
  ${key}_FAILURE
  `

export default createTypes(`
  // Banner
  ${asyncTypes('FIND_BANNERS')}
  ${asyncTypes('SAVE_BANNER')}
  ${asyncTypes('REMOVE_BANNER')}

  // Company
  ${asyncTypes('FIND_COMPANIES')}
  ${asyncTypes('FIND_COMPANY_OPTIONS')}

  // Giveaway
  ${asyncTypes('FIND_ALL_GIVEAWAYS')}
  ${asyncTypes('FIND_ONE_GIVEAWAY')}
  ${asyncTypes('ADD_GIVEAWAY')}
  ${asyncTypes('SAVE_GIVEAWAY')}
  ${asyncTypes('REMOVE_GIVEAWAY')}

  // Order
  ${asyncTypes('ADD_TO_CART')}
  ${asyncTypes('SAVE_CART')}
  ${asyncTypes('GET_CART')}
  ${asyncTypes('FIND_ORDERS')}
  ${asyncTypes('FIND_ALL_ORDERS')}
  ${asyncTypes('SAVE_ORDER')}
  ${asyncTypes('CHECKOUT')}
  ${asyncTypes('UPLOAD_INVOICE')}
  ${asyncTypes('REORDER')}
  ${asyncTypes('CREATE_PACK_PDF')}
  ${asyncTypes('CREATE_CW_ORDER')}

  // Payment
  ${asyncTypes('NOTIFY_PAYMENT')}
  ${asyncTypes('FIND_PAYMENTS')}
  ${asyncTypes('FIND_ALL_PAYMENTS')}
  ${asyncTypes('SAVE_PAYMENT')}

  // Price
  ${asyncTypes('FIND_PRICES')}

  // Product
  ${asyncTypes('FIND_BEST_SELLING_PRODUCTS')}
  ${asyncTypes('FIND_PROMOTIONAL_PRODUCTS')}
  ${asyncTypes('FIND_GIVEAWAY_PRODUCTS')}
  ${asyncTypes('FIND_HOME_PRODUCTS')}
  ${asyncTypes('FIND_PRICES')}
  ${asyncTypes('FIND_PRODUCTS')}
  ${asyncTypes('FIND_ALL_PRODUCTS')}
  ${asyncTypes('FIND_ONE_PRODUCT')}
  ${asyncTypes('IMPORT_PRODUCTS')}
  ${asyncTypes('IMPORT_TAGS')}
  ${asyncTypes('IMPORT_CONFIGS')}
  ${asyncTypes('IMPORT_STOCKS')}
  ${asyncTypes('IMPORT_BIS')}
  ${asyncTypes('IMPORT_FD')}
  ${asyncTypes('SAVE_PRODUCT')}
  ${asyncTypes('FIND_TAGS')}
  ${asyncTypes('FIND_PRODUCT_RECOMMENDATIONS')}
  ${asyncTypes('AGGREGATE_PRODUCTS')}
  ${asyncTypes('FIND_BIS_PRODUCTS')}

  ${asyncTypes('FIND_PRODUCT_IMAGES')}
  ${asyncTypes('ADD_PRODUCT_IMAGE')}
  ${asyncTypes('REMOVE_PRODUCT_IMAGE')}

  // Promocode
  ${asyncTypes('FIND_ALL_PROMOCODES')}
  ${asyncTypes('FIND_ONE_PROMOCODE')}
  ${asyncTypes('ADD_PROMOCODE')}
  ${asyncTypes('SAVE_PROMOCODE')}

  // Reward
  ${asyncTypes('FIND_ALL_REWARDS')}
  ${asyncTypes('FIND_ONE_REWARD')}
  ${asyncTypes('ADD_REWARD')}
  ${asyncTypes('SAVE_REWARD')}

  // User
  ${asyncTypes('FIND_USERS')}
  ${asyncTypes('FIND_ONE_USER')}
  ${asyncTypes('EDIT_PROFILE')}
  ${asyncTypes('SAVE_USER')}
  ${asyncTypes('REMOVE_USER')}
  ${asyncTypes('SIGNUP')}
  ${asyncTypes('LOGIN')}
  ${asyncTypes('LOGOUT')}
  ${asyncTypes('FORGOT_PASSWORD')}
  ${asyncTypes('SET_NEW_PASSWORD')}
  ${asyncTypes('VERIFY')}
  ${asyncTypes('FIND_GIVEAWAYS')}

  // Wishlist
  ${asyncTypes('FIND_WISHLIST')}
  ${asyncTypes('ADD_TO_WISHLIST')}
  ${asyncTypes('REMOVE_FROM_WISHLIST')}

  SET_INITIAL
  SAVE_SEARCH_STATE
`)



/** WEBPACK FOOTER **
 ** ./src/redux/Types.js
 **/